import jwt_decode from "jwt-decode"

const setToken = (token: string) => {
  console.log("Setting token:", token)
  localStorage.setItem("token", token)
}

const setUsername = (username: string) => {
  localStorage.setItem("username", username)
}

const setRefreshToken = (token: string) => {
  console.log("Setting refresh token:", token)
  localStorage.setItem("refreshToken", token)
}

const getToken = (): string | null => {
  const token = localStorage.getItem("token")
  return token !== null ? token : null // Explicitly return null if no token is found
}

const getUsername = (): string | null => {
  const token = localStorage.getItem("username")
  return token !== null ? token : null // Explicitly return null if no token is found
}

const getRefreshToken = (): string | null => {
  const token = localStorage.getItem("refreshToken")
  return token !== null ? token : null // Explicitly return null if no refresh token is found
}

const getDecodedJwt = (): Record<string, any> | null => {
  try {
    const token = getToken()
    if (token) {
      return jwt_decode(token)
    }
    return null
  } catch (e) {
    return null
  }
}

const setUserRole = (role: string) => {
  console.log("Setting user role:", role)
  localStorage.setItem("role", role)
}

const getUserRole = (): string | null => {
  const role = localStorage.getItem("role")
  return role !== null ? role : null
}

const removeTokens = () => {
  localStorage.removeItem("token")
  localStorage.removeItem("refreshToken")
  localStorage.removeItem("role")
}

const logOut = () => {
  removeTokens()
  window.location.replace("/auth")
}

const isAuthenticated = (): boolean => {
  try {
    const decodedToken = getDecodedJwt()
    if (!decodedToken) return false

    const { exp } = decodedToken as { exp: number }
    const currentTime = Date.now() / 1000

    return exp > currentTime
  } catch (e) {
    return false
  }
}

const setCustomerId = (customerId: string | number) => {
  console.log("Setting customer ID:", customerId)
  localStorage.setItem("customerId", customerId.toString())
}

const getCustomerId = (): string | null => {
  const customerId = localStorage.getItem("customerId")
  return customerId !== null ? customerId : null
}

const Auth = {
  isAuthenticated,
  getDecodedJwt,
  setCustomerId,
  getCustomerId,
  setToken,
  getToken,
  setRefreshToken,
  getRefreshToken,
  setUserRole,
  getUsername,
  setUsername,
  getUserRole,
  removeTokens,
  logOut,
}

export default Auth
